import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// ?safe&utm_source=FB&country=US&area=female&exp=web_input_screens_before_paywall~1
			funnel: {
				id: 'ob-female-funnel-input-screens-before-paywall',
				locale: ['en'],
			},
		},
	},
]

export default config
